// src/sections/ModulbefestigungSection.jsx
import React from "react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import { useState, useEffect } from "react";
import { Box, Button } from "@chakra-ui/react";


export default function ModulbefestigungSection({ selectedAnlageId }) {
  const options = ["Klemmen", "Einschubsystem", "Schraube an UK", "andere"];
  const [checkedValues, setCheckedValues] = useState([]);


  // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/modulbefestigung/anlage/${selectedAnlageId}`)
      .then((res) => {
        const data = res.data;
        const loaded = [];

        if (data.klemmen) loaded.push("Klemmen");
        if (data.einschubsystem) loaded.push("Einschubsystem");
        if (data.schraubeAnUK) loaded.push("Schraube an UK");
        if (data.andere) loaded.push("andere");

        setCheckedValues(loaded);
      })
      .catch(() => setCheckedValues([]));
  }, [selectedAnlageId]);



  const handleSave = async () => {
    const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      klemmen: checked.includes("Klemmen"),
      einschubsystem: checked.includes("Einschubsystem"),
      schraubeAnUK: checked.includes("Schraube an UK"),
      andere: checked.includes("andere"),
    };

    try {
      // try load existing
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/modulbefestigung/anlage/${selectedAnlageId}`
      );

      // update
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/modulbefestigung/${res.data.id}`,
        payload
      );

      showSuccess("Gespeichert", "Modulbefestigung wurde aktualisiert");
    } catch {
      // create
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/modulbefestigung`,
        payload
      );

      showSuccess("Gespeichert", "Modulbefestigung wurde gespeichert");
    }
  };

  return (
       <Box 
         p={8} 
         bg="white" 
         borderRadius="xl" 
         boxShadow="md" 
         mt={6} 
         mb={10} 
         maxW="fit-content"
       >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        MODULBEFESTIGUNG
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <input
              type="checkbox"
              value={opt}
              checked={checkedValues.includes(opt)}
              onChange={(e) =>
                setCheckedValues((prev) =>
                  e.target.checked
                    ? [...prev, opt]
                    : prev.filter((v) => v !== opt)
                )
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
           bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Modulbefestigung
      </Button>
    </Box>
  );
}